import { COMBINED_TREE_PICKER_KEY_SEPARATOR } from 'consts/combinedTreePickerKeySeparator';

export const getCombinedTreePickerKey = (
    childTreePickerNodeId: string,
    parentTreePickerNodeId: string,
) => `${parentTreePickerNodeId}${COMBINED_TREE_PICKER_KEY_SEPARATOR}${childTreePickerNodeId}`;
